import styled from 'styled-components'
import { Card, Input, Button, Form, message } from 'antd'
import { useEffect, useState } from 'react'
import { LoginOutlined } from '@ant-design/icons'
import { setSession } from '../../api'
import { afterLoginTarget } from '../../utils/loginRedirect'

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #eee;
`

export default () => {
  const [email, setEmail] = useState(null)
  const [password, setPassword] = useState(null)
  const [loading, setLoading] = useState(false)

  const [messageApi, contextHolder] = message.useMessage()

  useEffect(() => {
    const reason = new URLSearchParams(window.location.search).get('reason')

    if (reason === 'sessionExpired') {
      messageApi.open({
        type: 'warning',
        content: i18n('login.sessionExpired'),
      })
    } else if (reason === 'noPermission') {
      messageApi.open({
        type: 'warning',
        content: i18n('login.noPermission'),
      })
    }
  }, [])

  return (
    <Container>
      {contextHolder}
      <img style={{ maxWidth: 200, marginBottom: 64 }} src="https://app.horoluma.com/logo.svg" />
      <Card style={{ width: '100%', maxWidth: '500px' }} title={i18n('login.title')}>
        <Form
          layout="vertical"
          onFinish={() => {
            setLoading(true)

            fetch(`${global.WatchStorage.backendUrl}/api/v1/auth/login`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                email,
                password,
              }),
            }).then(async data => {
              console.log(data)
              setLoading(false)

              if (data.status === 201) {
                messageApi.open({
                  type: 'success',
                  content: i18n('login.success'),
                })

                const token = await data.text()
                setSession({ token })

                // HOR-92 (Review ADM-4 / F1): zurueck zum gemerkten Ziel (?redirect=, nur relative Pfade
                // derselben Origin), damit Deep Links wie /services?open=123 den Login ueberleben.
                document.location.href = afterLoginTarget(window.location.search)
              } else {
                messageApi.open({
                  type: 'warning',
                  content: i18n('login.failed'),
                })
              }
            })
          }}
        >
          <Form.Item label={i18n('login.email')}>
            <Input
              readOnly={loading}
              spellCheck={false}
              value={email}
              onChange={e => setEmail((e.target.value || '').toLowerCase().trim())}
              size="large"
              placeholder={i18n('login.emailPlaceholder')}
            />
          </Form.Item>
          <Form.Item label={i18n('login.password')}>
            <Input
              readOnly={loading}
              spellCheck={false}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value || '')}
              size="large"
              placeholder={i18n('login.passwordPlaceholder')}
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button icon={<LoginOutlined />} loading={loading} htmlType="submit" disabled={!email || !password} block type="primary" size="large">
              {i18n('login.submit')}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Container>
  )
}
